import { jobData } from '../jobs/jobData';
import { internData } from '../jobs/internData';

/**
 * Combine job and internship data
 */
export const allJobsData = [...jobData, ...internData];

/**
 * Get job by ID
 * @param {string} id - Job ID to find
 * @returns {Object|null} - Job object or null if not found
 */
export const getJobById = id => {
  return allJobsData.find(job => job.id === id) || null;
};

/**
 * Check if a job is an internship
 * @param {string} id - Job ID to check
 * @returns {boolean} - True if internship, false otherwise
 */
export const isInternship = id => {
  return internData.some(item => item.id === id);
};

/**
 * Get all jobs (excluding internships)
 * @returns {Array} - Array of job objects
 */
export const getAllJobs = () => jobData;

/**
 * Get all internships
 * @returns {Array} - Array of internship objects
 */
export const getAllInternships = () => internData;

export { jobData, internData };
